import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Force dark mode on the entire site
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
